import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { CometUserAuthenticationWebHandler_getUser } from '@zg-rentals/ts-leasing-client';

type TenantAuthCheckWrapperProps = PropsWithChildren<Record<string, unknown>>;

export const TenantAuthCheckWrapper = ({ children }: TenantAuthCheckWrapperProps) => {
  const [authState, setAuthState] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await CometUserAuthenticationWebHandler_getUser({});
        setAuthState(user?.isLoggedIn ? 'authenticated' : 'unauthenticated');
      } catch {
        setAuthState('unauthenticated');
      }
    };

    checkAuth();
  }, []);

  if (authState === 'loading') {
    return null;
  }

  if (authState === 'unauthenticated') {
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = `/user/acct/login/?url=${returnUrl}`;
    return null;
  }

  return <>{children}</>;
};
